export const TIPO_VISAO = {
  PRINCIPAL: 1,
  AGRUPAMENTO: 2,
  ANALITICO: 3,
  EXTERNO: 4,
  INTERNO: 5,
  MODULOFIXO: 6,
  MODULODINAMICO: 7,
};
